import { useLanguage } from "@/i18n/LanguageContext";

export function Marquee() {
  const { t } = useLanguage();
  const items = t.home.marquee;
  const row = [...items, ...items];
  return (
    <div className="border-y border-border bg-sand-muted/60 overflow-hidden py-4" aria-hidden="true">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-mono text-xs uppercase tracking-[0.22em] text-muted-foreground">
            {item}
            <span className="text-ochre">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
